//
//
//
//
//
//
//
//
//

import { MapPinIcon } from 'vue-feather-icons'
import TaskLocation from '@/components/tasks/TaskLocation'
import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'

export default {
  name: 'TaskDetailsLocation',
  components: {
    TaskDetailsItem,
    TaskLocation,
    MapPinIcon
  },
  props: {
    task: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    location () {
      if (this.task.location === 'remote') {
        return this.$t('tasks.details.remote')
      } else {
        return this.$t('tasks.details.onsite')
      }
    }
  }
}
